// detect View used for sitecat
export const detectView = () => {
    var width = window.innerWidth;
    if(width>1539) return "Xwide";
    else if(width <= 1539 && width>1023) return "Wide";
    else if(width <= 1023 && width > 754) return "Middle";
    else return "Narrow";
} 
